export default [
    {
        code: 'ui.index',
        name: '工作台',
        role: 'auth',
        path: 'index',
        comp: 'Index.vue'
    },
    {
        code: 'ui.sys',
        name: '系统管理',
        role: 'PlatAdmin',
        subs: [
            {
                code: 'sys.unit',
                name: '单位信息',
                role: 'PlatAdmin',
                path: 'sys/unit',
                comp: 'sys/Unit.vue'
            },
            {
                code: 'sys.emp',
                name: '员工信息',
                role: 'PlatAdmin',
                path: 'sys/emp',
                comp: 'sys/Emp.vue'
            }
        ]
    },
    {
        code: 'ui.rec',
        name: '招聘管理',
        role: 'PlatAdmin,PlatAudit,PlatView,UnitAdmin',
        subs: [
            {
                code: 'rec.plan',
                name: '招聘计划',
                role: 'PlatAdmin',
                path: 'rec/plan',
                comp: 'rec/Plan.vue'
            },
            {
                code: 'rec.regs',
                name: '报名列表',
                role: 'PlatAdmin,PlatAudit,PlatView,UnitAdmin',
                path: 'rec/regs',
                comp: 'rec/Regs.vue'
            },
            {
                code: 'rec.proctor',
                name: '监考人员',
                role: 'PlatAdmin',
                path: 'rec/proctor',
                comp: 'rec/Proctor.vue'
            },
            {
                code: 'rec.ers',
                name: '成绩信息',
                role: 'PlatAdmin',
                path: 'rec/ers',
                comp: 'rec/Ers.vue'
            },
            {
                code: 'rec.stat',
                name: '报名统计',
                role: 'PlatAdmin',
                path: 'rec/stat',
                comp: 'rec/Stat.vue'
            },
            {
                code: 'rec.vstat',
                name: '进场统计',
                role: 'PlatAdmin',
                path: 'rec/vstat',
                comp: 'rec/VStat.vue'
            },
            {
                code: 'rec.pbill',
                name: '缴费信息',
                role: 'PlatAdmin',
                path: 'rec/pbill',
                comp: 'rec/Pbill.vue'
            },
            {
                code: 'rec.settle',
                name: '核算信息',
                role: 'PlatAdmin',
                path: 'rec/settle',
                comp: 'rec/Settle.vue'
            }
        ]
    },
    {
        code: 'ui.site',
        name: '网站管理',
        role: 'PlatAdmin,PlatCms',
        subs: [
            // {
            //     code: 'site.config',
            //     name: '网站设置',
            //     role: 'PlatAdmin',
            //     path: 'site/config',
            //     comp: 'site/Config.vue'
            // },
            {
                code: 'site.cata',
                name: '栏目管理',
                role: 'PlatAdmin,PlatCms',
                path: 'site/catalog',
                comp: 'site/Catalog.vue'
            },
            {
                code: 'site.article',
                name: '文章管理',
                role: 'PlatAdmin,PlatCms',
                path: 'site/article',
                comp: 'site/Article.vue'
            },
            {
                code: 'site.carousel',
                name: '轮播管理',
                role: 'PlatAdmin,PlatCms',
                path: 'site/carousel',
                comp: 'site/Carousel.vue'
            },
            {
                code: 'site.blogroll',
                name: '友链管理',
                role: 'PlatAdmin,PlatCms',
                path: 'site/blogroll',
                comp: 'site/Blogroll.vue'
            },
            {
                code: 'site.zhuanti',
                name: '专题管理',
                role: 'PlatAdmin,PlatCms',
                path: 'site/zhuanti',
                comp: 'site/Zhuanti.vue'
            }
        ]
    }
]
